import React, { useRef, useState } from 'react'
import {
	UploadPhotoStyle,
	Body,
	Previews,
	Preview,
	ButtonUpload,
} from './style'
import { removePhotoReq, uploadPhotoReq } from './api'
import { Icon } from '../Icon'
import { ModelUploadImage } from 'models/modelUploadImage'
import { LoaderSpinner } from 'components/Loader'
import { showPopup } from '../Modal/slices'
import { useDispatch } from 'react-redux'

/**
 * isValueAcceptable {Function}
 * @description - check image for loading and find is it exceptable or not
 * @return {Boolean}
 * */
const isValueAcceptable = (imageFile) => {
	let allowedImageExtensions = ['jpeg', 'jpg', 'png', 'gif']
	let isValueAcceptable = true
	let fileSize = imageFile.size / (1024 * 1024).toFixed(2)

	// check image size
	if (parseFloat(fileSize) > 15) {
		isValueAcceptable = false
	}

	// check image type
	if (!imageFile.type) {
		isValueAcceptable = false
	}

	// check image type extension
	if (imageFile.type) {
		let currentType = imageFile.type.split('/')[1]
		if (!allowedImageExtensions.includes(currentType)) {
			isValueAcceptable = false
		}
	}

	return isValueAcceptable
}

const UploadPhoto = ({
	buttonName,
	defaultValue,
	itemIndex,
	afterLoadingAction = () => {},
	afterRemoveAction = () => {},
}) => {
	const [imgs, setImgs] = useState(defaultValue || [])
	const [isLoading, setLoading] = useState(false)
	const uploadInputRef = useRef()
	const dispatch = useDispatch()

	const handlerUpload = async (event) => {
		setLoading(true)
		let arr = []
		for (let [key, value] of Object.entries(event.target.files)) {
			if (value && isValueAcceptable(value)) {
				const res = await uploadPhotoReq(value)
				arr.push(ModelUploadImage(res))
			} else {
				dispatch(
					showPopup({
						type: 'imageSizeError',
					})
				)
			}
		}
		let uploadedImages = [...imgs, ...arr]

		await setImgs(uploadedImages)
		await afterLoadingAction(uploadedImages, itemIndex)

		uploadInputRef.current.value = null
		setLoading(false)
	}
	const removePhoto = async (id) => {
		setLoading(true)

		let removedImages = imgs.filter((img) => img.imageId !== id)
		await removePhotoReq(id)
		await setImgs(removedImages)
		await afterRemoveAction(removedImages, itemIndex)
		setLoading(false)
	}

	return (
		<UploadPhotoStyle>
			<Body>
				<ButtonUpload uppercase='true' as='label' w100 dark>
					{buttonName}
					<input
						ref={uploadInputRef}
						onChange={handlerUpload}
						type='file'
						name='file[]'
						accept='image/*'
						multiple
					/>
				</ButtonUpload>
				<Previews
					isLoading={isLoading}
					isSingle={imgs && imgs.length < 4}
				>
					{!!isLoading && (
						<LoaderSpinner isImageUploader={true} isActive={true} />
					)}

					{imgs?.map((img, idx) => (
						<div key={idx}>
							<Preview onClick={() => removePhoto(img.imageId)}>
								<Icon component='trash' />
								<img src={img.imagePath} alt={img.imageId} />
							</Preview>
						</div>
					))}
				</Previews>
			</Body>
		</UploadPhotoStyle>
	)
}
export default UploadPhoto
